export default __webpack_public_path__ + "static/media/alertas.ed5e5a6a.svg";